module.exports = __webpack_public_path__ + "img/1_002.50fde3a0.jpg";